import { Component, OnDestroy, OnInit } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';
import { PersistenceConsentConfig, PersistenceConsentData, PersistenceService } from '../../services/persistence.service';
import { HttpClient } from '@angular/common/http';
import { LocalizationService } from '../../services/localization.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-pg-cookie-consent',
    templateUrl: './pg-cookie-consent.component.html',
    styleUrls: ['./pg-cookie-consent.component.scss'],
    standalone: false
})
export class PgCookieConsentComponent implements OnInit, OnDestroy {

    constructor(private environmentService:EnvironmentService, private persistenceService:PersistenceService, private http:HttpClient, private localizationService:LocalizationService) { }

    showConsent = false;
    consentData:PersistenceConsentData = null;
    consentConfig:Array<PersistenceConsentConfig> = null;

    customizeCookies = false;

    privacyPolicyURL:string = null;

    private _consentReviewSubscription:Subscription = null;

    ngOnInit(): void {
        this.privacyPolicyURL = this.localizationService.getPrivacyPolicyURL(this.environmentService.publicRealm?.id)

        this.showConsent = this.persistenceService.needConsent;
        this.consentConfig = this.persistenceService.consentConfig;
        this._loadConsentData();

        this._consentReviewSubscription = this.persistenceService.consentReviewRequest.subscribe(() => {
            this.openConsentReview();
        })
    }

    ngOnDestroy(): void {
        this._consentReviewSubscription?.unsubscribe();
    }

    openConsentReview() {
        this._loadConsentData();
        this.customizeCookies = true;
        this.showConsent = true;
    }

    private _loadConsentData() {
        this.consentData = JSON.parse(JSON.stringify(this.persistenceService.consentData));

        if(this.environmentService.ElectronWrapper == null) {
            if(this.consentData != null) {
                for(let _config of this.consentConfig) {
                    if(_config.required) this.consentData[_config.id] = true;
                    else if(this.consentData[_config.id] == undefined) this.consentData[_config.id] = false;
                }
            }
        }
    }

    saveConsent(mode?: 'all'|'none') {
        if(mode) {
            for(let _config of this.consentConfig) {
                if(mode == 'all') this.consentData[_config.id] = true;
                else if(mode == 'none') this.consentData[_config.id] = !!_config.required;
            }
        }

        this.persistenceService.saveConsent(this.consentData)
        
        this.http.post(this.environmentService.environment.APIUrl + '/acceptPrivacy', null).subscribe(() => {}, () => {})
    }
}
